import { initCentralAuth } from '@mg/auth-client';
import type { PublicConfig } from '../api/types.js';

/**
 * Wires up the shared auth-service session from the configuration the backend served.
 *
 * Read at runtime rather than baked in, because one build serves staging and production and
 * their auth origins differ. Returns false when there is no auth service to talk to — local
 * development — and the caller then renders with nobody signed in.
 */
export function initAuth(config: PublicConfig): boolean {
  if (!config.authRequired || !config.authUrl) return false;
  initCentralAuth({
    appName: 'event explorer',
    authUrl: config.authUrl,
    sessionCookieDomain: config.cookieDomain ?? undefined,
  });
  return true;
}
